import React from "react";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { XCircle } from "lucide-react";

/**
 * CancelModal — Cancelación permanente de una provisión.
 *
 * Extraído 1:1 desde `pages/ProvisionsPage.js`. Exige un motivo de cancelación; al
 * confirmar, la provisión queda CANCELADA (el cliente no se da de alta ni se activan servicios).
 *
 * @param {boolean}  props.cancelModalOpen       Apertura del diálogo.
 * @param {Function} props.setCancelModalOpen     Setter del flag de apertura.
 * @param {string}   props.cancelReason           Motivo de la cancelación.
 * @param {Function} props.setCancelReason        Setter del motivo.
 * @param {Function} props.handleCancelProvision  Confirma la cancelación (deshabilitado sin motivo).
 */
export const CancelModal = ({
  cancelModalOpen,
  setCancelModalOpen,
  cancelReason,
  setCancelReason,
  handleCancelProvision,
}) => {
  return (
      <Dialog open={cancelModalOpen} onOpenChange={setCancelModalOpen}>
        <DialogContent className="bg-[#0A0A35] border-[#1E1E5F] text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="text-white font-heading flex items-center gap-2">
              <XCircle className="h-5 w-5 text-red-400" />
              Cancelar Provisión
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 mt-4">
            <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/30">
              <p className="text-red-400 text-sm">
                Esta acción cancelará la provisión permanentemente. El cliente no será dado de alta y los servicios no serán activados.
              </p>
            </div>
            <div>
              <Label className="text-slate-300">Motivo de la cancelación *</Label>
              <Textarea
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                placeholder="Explica por qué se cancela esta provisión..."
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white h-24"
              />
            </div>
          </div>
          <div className="flex justify-end gap-3 mt-6">
            <Button
              variant="outline"
              onClick={() => {
                setCancelModalOpen(false);
                setCancelReason("");
              }}
              className="border-[#1E1E5F] text-slate-300"
            >
              Volver
            </Button>
            <Button
              onClick={handleCancelProvision}
              disabled={!cancelReason.trim()}
              className="bg-red-500 text-white hover:bg-red-600 disabled:bg-red-500/50"
            >
              <XCircle className="h-4 w-4 mr-2" />
              Confirmar Cancelación
            </Button>
          </div>
        </DialogContent>
      </Dialog>
  );
};
